<template>
  <div class="RedCouponPopoverContainer">
    <nut-animate type='ripple' :loop='true'>
      <div class="colFlex bothCenter wd100" style="position: absolute;top: 15%">
        <img :src="data.couponAvatar"
             class="sqr60 brd40"/>
        <span class="gold mt20">{{ data.couponNickName }}</span>
        <span class="gold mt20">给您发了一个红包</span>
      </div>
      <img src="https://cdn.waityou.online/b2146774-be82-05b4-5cce-85e3433a2977.png"
           style="width: 80vw"/>
    </nut-animate>
  </div>
</template>

<script>
export default {
  name: "RedCouponPopover",
  props: {
    data: {
      type: Object,
      default: ()=>{
        return {

        }
      }
    },
  },
  methods: {
    init() {

    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.RedCouponPopoverContainer {
  display: flex;
  flex-direction: column;
  position: relative;

  .gold {
    color: #FDFAD8;
  }
}
</style>